export default "__VITE_ASSET__17b6e07b__"